import dayjs from 'dayjs';
import { SsccStatus } from '../common';
import { SSCCProps } from '../datastore/ssccs';

export function deduplicateSSCCs(ssccs: SSCCProps[]): SSCCProps[] {
  const seen = new Map<string, SSCCProps>();

  ssccs.forEach((sscc) => {
    const existing = seen.get(sscc.id);
    if (!existing) {
      seen.set(sscc.id, sscc);
    } else {
      const existingTime = existing.staged || existing.open || dayjs(0);
      const currentTime = sscc.staged || sscc.open || dayjs(0);

      if (currentTime.isAfter(existingTime)) {
        seen.set(sscc.id, sscc);
      }
    }
  });

  return Array.from(seen.values());
}

export function resolveDateBounds(dateLimit: number | null) {
  const date = dateLimit && dateLimit !== 0 ? dayjs().subtract(dateLimit, 'days') : null;
  const today = dayjs().add(1, 'day').toISOString();
  const endDateString = date?.toISOString() ?? '';

  return { today, endDateString };
}

export function shouldIncludeSscc(sscc: SSCCProps, dateLimit: number | null) {
  if (sscc.status === SsccStatus.cancelled) {
    return false;
  }

  const openIso = sscc.open?.toISOString();
  if (!openIso) {
    return false;
  }

  const { today, endDateString } = resolveDateBounds(dateLimit);
  return openIso >= endDateString && openIso <= today;
}

export function upsertDeduplicated(items: SSCCProps[], nextItem: SSCCProps) {
  const index = items.findIndex((item) => item.id === nextItem.id);

  if (index === -1) {
    return [...items, nextItem];
  }

  const cloned = items.slice();
  cloned[index] = nextItem;
  return cloned;
}
